import styled from "styled-components"
import theme from "utils/theme"
export const Wrapper = styled.div`
  height: 100%;
  min-height: 200px;
  width: calc(100% - 48px); //48px por causa do padding de 24px de cada lado, assim não quebra a tela
  background-color: white;
  padding: 16px 24px;
  border-radius: 16px;
  overflow-y: hidden;
  overflow-x: auto;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132);
  margin: 8px 0px;
`

export const Container = styled.div`
  height: 100%;
  min-height: 340px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: auto;
`

export const Content = styled.div`
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  overflow-x: auto;
  padding-right: 16px;
`

export const TimelineItem = styled.div`
  ${({ disabled }) => disabled ?
    `background-color: ${theme.colors.white};` :
    `background-color: ${theme.colors.secondary};
     margin: 10px;`
  }
  padding: 5px 16px;
  min-height: 20px;
  color: white;
  border-radius: 10px;
  position: relative;
  width:100%;
  display: flex;
  justify-content: center;
`

export const TimelineItemDetails = styled.div`
  width: 230px;
  height: 95px;
  position: absolute;
  ${({ disabled }) => disabled ?
    `background-color: ${theme.colors.lightGray};
     text-align: center;` :
    `background-color: ${theme.colors.white};
     text-align: start;`
  }
  ${({ isEven }) => isEven ? "top: -130px;" : "bottom: -130px;"}

  border: 1px solid ${theme.colors.lightGray};
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  padding: 10px;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > div.timeline-item-text {
    font-size: 16px;
    font-weight: 400;
    ${({ disabled }) => disabled ?
    `color: ${theme.colors.gray};` :
    `color: ${theme.colors.black};`
  }
  }

  & > div.timeline-item-bottom {
    font-size: 14px;
    font-weight: 400;
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const TimelineDash = styled.div`
    padding: 0;
    margin: 0;
    min-width: 100px;
    border-bottom: 2px dashed #999999;
`